export const ARAC_TIPLERI = ["TIR", "KAMYON", "KAMYONET", "20DC", "40DC", "40HC", "ÖZEL"];
export const HIZMETLER = ["ANA HAT", "ŞEHİRİÇİ", "BÖLGE", "KOMPLE"];

// Ortalama yüklü sürüş tüketimi (lt / 100 km) — üretici ve filo ortalamaları, araca göre değiştirilebilir.
export const YAKIT_TABLOSU = [
  ["MERCEDES", "ACTROS", 29], ["MERCEDES", "AXOR", 31], ["MERCEDES", "ATEGO", 20], ["MERCEDES", "SPRINTER", 10.5],
  ["FORD", "F-MAX", 28.5], ["FORD", "CARGO", 31], ["FORD", "TRANSIT", 9.5],
  ["VOLVO", "FH", 30], ["VOLVO", "FM", 31], ["SCANIA", "R", 29.5], ["SCANIA", "S", 29], ["SCANIA", "G", 31],
  ["DAF", "XF", 28.5], ["DAF", "XG", 28], ["DAF", "CF", 30], ["MAN", "TGX", 30], ["MAN", "TGS", 31.5], ["MAN", "TGL", 18],
  ["RENAULT", "T", 30], ["RENAULT", "C", 32], ["IVECO", "S-WAY", 29.5], ["IVECO", "STRALIS", 31], ["IVECO", "DAILY", 11],
  ["ISUZU", "NPR", 15], ["ISUZU", "NQR", 17], ["MITSUBISHI", "CANTER", 14], ["BMC", "TUĞRA", 31], ["BMC", "PRO", 22],
  ["FIAT", "DUCATO", 9.5], ["RENAULT", "MASTER", 10], ["VOLKSWAGEN", "CRAFTER", 10], ["HYUNDAI", "HD", 16], ["OTOKAR", "ATLAS", 17],
];
const TIP_ORT = { TIR: 30, KAMYON: 22, KAMYONET: 11, "20DC": 30, "40DC": 31, "40HC": 31, ÖZEL: 25 };

export const yakitTahmin = (marka, model, tip) => {
  const m = String(marka || "").toLocaleUpperCase("tr-TR"), md = String(model || "").toLocaleUpperCase("tr-TR");
  const hit = YAKIT_TABLOSU.find(([a, b]) => m.includes(a) && md.includes(b)) || YAKIT_TABLOSU.find(([a]) => m.includes(a) && false);
  return hit ? hit[2] : TIP_ORT[tip] || 25;
};
